import {http} from "@/api/HttpClient.ts";
import type Encounter from "@/encounter/model/Encounter.ts";
import type {EncounterLight, EncounterLightOverride, EncounterLights} from "@/encounter/lights/EncounterLights.ts";
import type {DirectionalLight} from "@/dungeons/lighting/DirectionalLight.ts";

export async function saveLevelLighting(encounter: Encounter, levelId: string, light: DirectionalLight): Promise<EncounterLights> {
    return (await http.put<EncounterLights>(`/encounters/${encounter.id}/lights/levels/${levelId}`, light)).data;
}

export async function resetLevelLighting(encounter: Encounter, levelId: string): Promise<EncounterLights> {
    return (await http.delete<EncounterLights>(`/encounters/${encounter.id}/lights/levels/${levelId}`)).data;
}

export async function getEncounterLights(encounter: Encounter): Promise<EncounterLights> {
    return (await http.get<EncounterLights>(`/encounters/${encounter.id}/lights`)).data;
}

export async function saveLightOverride(encounter: Encounter, light: EncounterLightOverride): Promise<EncounterLights> {
    return (await http.put<EncounterLights>(`/encounters/${encounter.id}/lights/overrides/${light.lightId}`, light)).data;
}

export async function deleteLightOverride(encounter: Encounter, lightId: string): Promise<EncounterLights> {
    return (await http.delete<EncounterLights>(`/encounters/${encounter.id}/lights/overrides/${lightId}`)).data;
}

export async function saveEncounterLight(encounter: Encounter, light: EncounterLight): Promise<EncounterLights> {
    return (await http.put<EncounterLights>(`/encounters/${encounter.id}/lights/${light.id}`, light)).data;
}

export async function deleteEncounterLight(encounter: Encounter, lightId: string): Promise<EncounterLights> {
    return (await http.delete<EncounterLights>(`/encounters/${encounter.id}/lights/${lightId}`)).data;
}
